import { render, staticRenderFns } from "./CardMobilePremium.vue?vue&type=template&id=4cda8a94&scoped=true&"
import script from "./CardMobilePremium.vue?vue&type=script&lang=js&"
export * from "./CardMobilePremium.vue?vue&type=script&lang=js&"
import style0 from "./CardMobilePremium.vue?vue&type=style&index=0&id=4cda8a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda8a94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
